import { mapActions } from "vuex";

// step2、step3共用的寄送驗證碼至簡訊功能，提出來以mixin管理
export const mixinSendSmsMethods = {
    methods: {
        ...mapActions('identidySms', ['smsUidAction']),
        async sendSmsToPhone(params) {
            try {
                const deviceUid = this.$route.query.data||"";

                console.log('step3',deviceUid)
                const resultStatus = await this.smsUidAction(params);
                if (resultStatus === 200) {
                    if (this.$route.path === '/provisioning/step2')
                        this.$router.push(`/provisioning/step3?data=${encodeURIComponent(deviceUid)}`);
                }
            } catch (error) {
                this.combineErrMsg(error);
                this.$emit('responseStatus', this.msgObj);
            }
        },
        combineErrMsg(status) {
            switch (status) {
                // 3:設備不存在、4:設備停用
                case 3:
                case 4:
                    this.msgObj = {
                        ...this.msgObj,
                        visible: true,
                        title: '裝置不存在',
                        okText: '撥打電話',
                        cancelText: '否',
                        detailText: '查無此裝置資訊，請聯繫客服人員',
                        msgClass: 'msg_error_modal',
                    };
                    break;
                case 5:
                    this.msgObj = {
                        ...this.msgObj,
                        detailText: '簡訊發送失敗',
                        visible: true,
                        msgClass: 'msg_confirm_modal'
                    };
                    break;
                case 6:
                    this.msgObj = {
                        ...this.msgObj,
                        detailText: '簡訊超過額度 (簡訊發送量每日最多30次)',
                        visible: true,
                        msgClass: 'msg_confirm_modal'
                    };
                    break;
                case 7:
                    this.msgObj = {
                        ...this.msgObj,
                        detailText: '簡訊發送太頻繁 (請於1分鐘後重新發送)',
                        visible: true,
                        msgClass: 'msg_confirm_modal'
                    };
                    break;
                case 8:
                    this.msgObj = {
                        ...this.msgObj,
                        detailText: '裝置已開通',
                        visible: true,
                        msgClass: 'msg_confirm_modal'
                    };
                    break;
                case 9:
                case 40303:
                    this.msgObj = {
                        ...this.msgObj,
                        title: '無法開通',
                        detailText: '此車號已開通過',
                        visible: true,
                        msgClass: 'msg_confirm_modal'
                    };
                    break;
                default:
                    break;
            }
        },
    },
};

// 將modal上共用的方法(撥打電話、關閉modal)、存放api回傳狀態訊息的data，提出來以mixin管理
export const mixinModalMethods = {
    data() {
        return {
            responseMsgObj: {},
        }
    },
    methods: {
        getResponseMsg(msgData) {
            this.responseMsgObj = msgData;
        },
        callPhoneNumber() {
            location.href='tel:02-12345678';
            this.hideModal();
        },
        hideModal() {
            this.responseMsgObj.visible = false;
        },
    },
};

// export const mixinDeterminePageTransferMethods = {
//     mounted() {
//         // 每個頁面一進來，都抓取目前的開通狀態，依照狀態決定要留在該頁面或導到正確頁面
//         this.determineOpenStatus(sessionStorage.getItem('openStatus'));
//     },
//     methods: {
//         determineOpenStatus(status) {
//             switch (status) {
//                 // sessionStorage的openStatus若為空，導到landing page
//                 case null:
//                     this.$router.push('/qrcode');
//                     break;
//                 // sessionStorage的openStatus若為0，且目前的頁面不是開通流程的其中一頁，導到同意書頁面
//                 case '0':
//                     // 若目前頁面非開通流程的頁面，一律導到同意書頁面
//                     if (this.$route.path.indexOf('provisioning') === -1) {
//                         this.$router.push('/provisioning/step1');
//                     }
//                     // 若目前頁面在開通流程的頁面中，但不是同意書頁面以及開通資料頁面，且沒有輸入的姓名、車號、手機，導到同意書頁面
//                     else {
//                         if (this.$route.path !== '/provisioning/step1' && this.$route.path !== '/provisioning/step2') {
//                             if (!sessionStorage.getItem('name') || !sessionStorage.getItem('carNo') || !sessionStorage.getItem('phone')) {
//                                 this.$router.push('/provisioning/step1');
//                             }
//                         }
//                     }
//                     break;
//                 // sessionStorage的openStatus若為1，目前的頁面不是開通後個人資訊的其中一頁以及開通結果頁面，導到監控地圖
//                 case '1':
//                     if (this.$route.path.indexOf('individual') === -1 && this.$route.path !== '/provisioning/step4') {
//                         this.$router.push('/individual/monitor');
//                     }
//                     break;
//                 // sessionStorage的openStatus若為2，導到裝置資訊
//                 case '2':
//                     this.$router.push('/individual/deviceInfo');
//                     break;
//                 default:
//                     break;
//             }
//         },
//     },
// };
